module.exports = __webpack_public_path__ + "static/media/IMG_8903.8144f51e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/horizontal/IMG_8903.jpg
// module id = 159
// module chunks = 0